<template>
  <div class="programs-events-module">
    <template v-if="programs.length">
      <div class="columns">
        <div class="column">
          <div class="card">
            <template v-if="cardOneLoading">
              <div class="card-content card-loading">
                <i class="fas fa-2x fa-spinner fa-spin"/>
              </div>
            </template>
            <template v-else>
              <div class="card-content">
                <div class="program-header">
                  <h2 v-if="!cardOneLoading">
                    <a
						:href="programs[current].link"
						v-html="programs[current].title"/>
                  </h2>
                  	<time
						:title="programs[current].date + ' to ' + programs[current].date_end">
						{{ programs[current].date }} - {{ programs[current].date_end }}
					</time>
                </div>
                <div class="program-content">
                  <p><strong>Time:</strong> {{ programs[current].time }}</p>
                  <p><strong>Location:</strong> {{ programs[current].location }}</p>
                  <p><strong>Details:</strong> <span v-html="getContent(programs[current])" /> <a
                    :href="programs[current].link"
                    class="read-more">read more...</a></p>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="column">
          <div class="card">
            <template v-if="cardTwoLoading">
              <div class="card-content card-loading">
                <i class="fas fa-2x fa-spinner fa-spin"/>
              </div>
            </template>
            <template v-else>
              <div class="card-content">
                <div class="program-header">
                  <h2>
                    <a 
						:href="programs[next].link"
						v-html="programs[next].title"/>
                  </h2>
                  	<time
						:title="programs[next].date + ' to ' + programs[next].date_end">
						{{ programs[next].date }} - {{ programs[next].date_end }}
					</time>
                </div>
                <div class="program-content">
                  <p><strong>Time:</strong> {{ programs[next].time }}</p>
                  <p><strong>Location:</strong> {{ programs[next].location }}</p>
                  <p><strong>Details:</strong> <span v-html="getContent(programs[next])" /> <a
                    :href="programs[next].link"
                    class="read-more">read more...</a></p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="program-controls">
        <span @click="goLeft"><i class="fas fa-4x fa-angle-left"/></span>
        <span @click="goRight"><i class="fas fa-4x fa-angle-right"/></span>
      </div>
    </template>
    <template v-else>
      <p>No events currently scheduled</p>
    </template>
  </div>
</template>
 
<script>
  export default {
    props: {
      programs: {
        type: [Array],
        default: () => {}
      }
    },
    data() {
      return {
        start: 0,
        cardOneLoading: false,
        cardTwoLoading: false
      }
    },
    computed: {
      current() {
        // current can move, but if start is outside the edge then reset it
        // This may need refactoring because of side effect. ie this was the fast approach
        if (this.start > (this.programs.length - 1)) this.start = 0
        if (this.start < 0) this.start = this.programs.length - 1
        return this.start
      },
      next() {
        // if the current is the last one then just show the first
        return this.current === (this.programs.length - 1) ? 0 : this.current + 1
      }
    },
    methods: {
      getContent(program) {
        return program.excerpt.length ? program.excerpt : program.content
      },
      goLeft() {
        if (this.cardOneLoading) return
        this.start -= 1
        this.cardOneLoading = true
        setTimeout(() => {
          this.cardOneLoading = false
        }, 500);
      },
      goRight() {
        if (this.cardTwoLoading) return
        this.start += 1
        this.cardTwoLoading = true
        setTimeout(() => {
          this.cardTwoLoading = false
        }, 500);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// assets/js/ProgramsAndEvents.vue